import { createSelector } from 'reselect';
import mapValues from 'lodash/mapValues';
import { getSpacesIsLoading } from 'spaces/store/selectors';
import {
  minimalDashboard,
  getDashboardsById,
  getAllWidgets,
} from '../dashboards/selectors';


export const getMyDashboardIsLoading = (state) => state.myDashboard.isLoading;

export const getMyDashboardCurrentBreakpoint = (state) => state.myDashboard.currentBreakpoint;

export const getMyDashboardDataIsLoading = createSelector(
  [getMyDashboardIsLoading, getSpacesIsLoading],
  (myDashboardIsLoading, spacesIsLoading) => myDashboardIsLoading || spacesIsLoading,
);


export const getMyDashboardId = (state) => state.myDashboard.dashboardId;

export const getMyDashboard = createSelector(
  [getDashboardsById, getMyDashboardId],
  (dashboards, id) => ((dashboards[id]) ? dashboards[id] : minimalDashboard),
);

export const getMyDashboardToolboxWidgets = createSelector(
  [getAllWidgets, getMyDashboard],
  (widgets, dashboard) => mapValues(
    dashboard.layout,
    (activeWidgets) => {
      const activeWidgetIds = activeWidgets.map((w) => w.i);
      return widgets.filter((w) => !activeWidgetIds.includes(w.id))
        .map((widget) => ({
          w: widget.width,
          h: widget.height,
          i: widget.id,
          x: 0,
          y: 0,
          static: false,
        })) || [];
    },
  ),
);
